import { ConfirmationAction } from '@app/components/ConfirmationAction';
import { useToast } from '@app/core/notifications';
import { Device, Service } from '@mi-front/core';
import { useAsyncViewCtx } from '@mi-front/ui';
import { Replay as RestartIcon } from '@mui/icons-material';
import { Button } from '@mui/material';
import { useIntl } from 'react-intl';
import { apiClient } from '../../../../../../api';

interface PropsP {
  readonly restart: () => void;
  readonly disabled?: boolean;
}

export function ServiceRestartP(p: PropsP) {
  const { $t } = useIntl();
  const { notifyInfo, notifyError } = useToast();

  return (
    <ConfirmationAction
      message={$t({
        id: 'streamerBox.viewScreen.services.actions.restart.prompt',
        defaultMessage: '¿Deseas realmente reiniciar el servicio?',
      })}
      onConfirm={async () => {
        try {
          await p.restart();
          notifyInfo(
            $t({
              id: 'streamerBox.viewScreen.services.actions.restart.done',
              defaultMessage: 'Reinicio de servicio solicitado',
            }),
          );
        } catch (err: any) {
          notifyError(
            $t({
              id: 'streamerBox.viewScreen.services.actions.restart.error',
              defaultMessage: 'No se pudo reiniciar el servicio',
            }),
          );
        }
      }}
    >
      {({ onClick }) => (
        <Button
          size="small"
          variant="outlined"
          color="primary"
          sx={{ marginLeft: 1 }}
          disabled={p.disabled}
          onClick={onClick}
          startIcon={<RestartIcon />}
        >
          {$t({
            id: 'streamerBox.viewScreen.services.actions.restart.btn',
            defaultMessage: 'Reiniciar',
          })}
        </Button>
      )}
    </ConfirmationAction>
  );
}

interface Props {
  readonly device: Device;
  readonly service: Service;
}

export function ServiceRestart(p: Props) {
  const { device, service } = p;
  const { reload } = useAsyncViewCtx();

  return (
    <ServiceRestartP
      restart={async () => {
        await apiClient.streamerBox.restartService(device.id, service.imageId);
        reload();
      }}
      disabled={
        !['Running', 'Downloading', 'Installing', 'Downloaded', 'Restarting'].includes(
          service.status,
        )
      }
    />
  );
}
